// extracted by mini-css-extract-plugin
export default {"content_item":"DragableItem_content_item__UXnWq"};